export const supportPhoneNumber = '+1(866) 506-3454';
